import { useEffect } from 'react';

import { useGetBranchMedicalExtensionQuery } from '@app/api/MedicalDocuments';
import { useUserPrint } from '@app/hooks';
import { useNotification } from '@app/providers/NotificationProvider/NotificationContext';
import { handleCatchError } from '@app/services';

import type { UseBranchMedicalExtensionEffectsProps } from '../types';

export const useBranchMedicalExtensionEffects = ({
  branchId,
}: UseBranchMedicalExtensionEffectsProps) => {
  const { showNotification } = useNotification();
  const { activeBranchId: ActiveBranchId } = useUserPrint();

  const {
    data,
    error,
    isLoading: isDataLoading,
  } = useGetBranchMedicalExtensionQuery({
    ActiveBranchId,
    branchId,
  });

  useEffect(() => {
    if (error) {
      showNotification(handleCatchError(error));
    }
  }, [error, showNotification]);

  return { isDataLoading, data };
};
